// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3h1gn","tab":"Tabs_tab__aIRB9","tabActive":"Tabs_tabActive__2r0W6"};